import { CurrentCityInterface, CityConfigInterface } from "components/curb/map/deckgl/interfaces";

export const GET_CURRENT_CITY = "GET_CURRENT_CITY";
export const CURRENT_CITY_RECEIVED = "CURRENT_CITY_RECEIVED";
export const GET_CURRENT_CITY_HAS_REAL_TIME_DATA = "GET_CURRENT_CITY_HAS_REAL_TIME_DATA";
export const CURRENT_CITY_HAS_REAL_TIME_DATA_RECEIVED = "CURRENT_CITY_HAS_REAL_TIME_DATA_RECEIVED";
export const GET_CITY_CONFIGURATION = "GET_CITY_CONFIGURATION";
export const CITY_CONFIGURATION_RECEIVED = "CITY_CONFIGURATION_RECEIVED";
export const SET_IS_USER_LOGGED_IN = "SET_IS_USER_LOGGED_IN";

export interface GetCurrentCity {
    type: typeof GET_CURRENT_CITY;
}

export interface CurrentCityReceived {
    type: typeof CURRENT_CITY_RECEIVED;
    payload: { data: CurrentCityInterface };
}

export interface GetCurrentCityHasRealTimeData {
    type: typeof GET_CURRENT_CITY_HAS_REAL_TIME_DATA;
}

export interface CurrentCityHasRealTimeDataReceived {
    type: typeof CURRENT_CITY_HAS_REAL_TIME_DATA_RECEIVED;
    payload: { message: boolean };
}

export interface GetCityConfiguration {
    type: typeof GET_CITY_CONFIGURATION;
}

export interface CityConfigurationReceived {
    type: typeof CITY_CONFIGURATION_RECEIVED;
    payload: { data: CityConfigInterface[] };
}

export interface CityTypesStateInterface {
    isCurrentCityReceived: boolean;
    currentCity: null | CurrentCityInterface;
    currentCityHasRealTimeData: boolean;
    cityConfig: CityConfigInterface[];
    isIframeView: boolean | null;
}

export type CityTypes =
    | GetCurrentCity
    | CurrentCityReceived
    | GetCurrentCityHasRealTimeData
    | CurrentCityHasRealTimeDataReceived
    | GetCityConfiguration
    | CityConfigurationReceived;
